import "./component-library131.mjs";
import normalizeComponent from "./component-library91.mjs";
const _sfc_main = {
  name: "GridContainer",
  props: {
    isFluid: { type: Boolean },
    padding: { type: Boolean },
    small: { type: Boolean }
  },
  computed: {
    classes() {
      const modifier = [];
      if (this.isFluid)
        modifier.push("grid-container--fluid");
      if (this.padding)
        modifier.push("grid-container--padding");
      if (this.small)
        modifier.push("grid-container--small");
      return modifier;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "grid-container", class: _vm.classes }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "5611420c",
  null,
  null
);
const GridContainer = __component__.exports;
export {
  GridContainer as default
};
